// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductInfo-button-40f7{background-color:#f94f0d}`, "",{"version":3,"sources":["webpack://./src/page/InferenceScreen/ProductInfo.module.scss"],"names":[],"mappings":"AAAA,yBACE,wBAAA","sourcesContent":[".button {\n  background-color: #F94F0D; // TSUM\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ProductInfo-button-40f7`
};
module.exports = ___CSS_LOADER_EXPORT___;
